import React from 'react';
import { Text } from '../Text';

const EmptyChatState = () => {
  return (
    <div
      className="flex flex-column align-items-center justify-content-center h-full text-center"
      style={{ background: '#f9fafb' }}
    >
      <i className="pi pi-comments mb-3" style={{ fontSize: '48px', color: '#b0b3b8' }} />

      <Text type="heading">No chat selected</Text>

      <Text type="sub-heading" cust="mt-1" style={{ color: '#8a8a8a' }}>
        Select a contact to start chatting
      </Text>
    </div>
  );
};

export default EmptyChatState;
